<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>

                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="wifi_channel"
                                name="nombre"
                                v-model="form.nombre"
                                :label="$t('cobrox.canalCobro.labels.nombre')"
                                :placeholder="$t('cobrox.canalCobro.labels.nombre')"
                                :error="hasInputErrors('nombre')"
                                :error-messages="getInputErrors('nombre')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>


                   <v-col cols="12" sm="6">
                        <cuenta-combobox v-model="form.cuentaDestinoDefault" :input-errors="inputErrors" />
                   </v-col>


                   <v-col cols="12" sm="6">
                        <tipo-canal-combobox v-model="form.tipoCanal" :input-errors="inputErrors" />
                   </v-col>


                    <v-col cols="12" sm="6">
                        <v-checkbox
                                prepend-icon="visibility"
                                name="visiblePorAgencia"
                                v-model="form.visiblePorAgencia"
                                :label="$t('cobrox.canalCobro.labels.visiblePorAgencia')"
                                :error="hasInputErrors('visiblePorAgencia')"
                                :error-messages="getInputErrors('visiblePorAgencia')"
                                color="secondary"

                        ></v-checkbox>
                    </v-col>

        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'

    import CuentaCombobox from "../../../../combobox/CuentaCombobox";
    import TipoCanalCombobox from "../../../../combobox/TipoCanalCombobox";




    export default {
        name: "CanalCobroForm",
        mixins: [InputErrorsByProps, RequiredRule    ],
        components: {CuentaCombobox,
TipoCanalCombobox,},
        props:{
            value: {
                type: Object,
                required: true
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        },
        data(){
            return {

            }
        }
    }
</script>

<style scoped>

</style>

